import { mapGetters } from 'vuex';
import infiniteLoading from 'vue-infinite-loading';
import stickyConstants from '@/helpers/stickyConstants';
import contractTile from '@/components/contracts-history/contract-tile/contract-tile.vue';
import plusMinusSign from '@/components/generics/plus-minus-sign/plus-minus-sign.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import { $txt } from '@/mixins/staticConf/utils';

const NO_CONTRACTS_MESSAGE = $txt('contracts-history.no-items');
const NO_MORE_CONTRACTS_MESSAGE = $txt('contracts-history.no-more-items');

export default {
  mixins: [
    contentLoaderMixin,
  ],
  props: {
    lightHeader: {
      type: Boolean,
      default: false,
    },
    showMarketNames: {
      type: Boolean,
      default: true,
    },
    contracts: {
      type: Array,
    },
    canLoadMore: {
      type: Boolean,
      default: true,
    },
    compactMode: { // keep mobile size on desktop
      type: Boolean,
      default: false,
    },
    marketId: Number, // indicates "see more" routing
  },
  components: {
    infiniteLoading,
    contractTile,
    plusMinusSign,
  },
  data() {
    return {
      loadedInfo: this.getLoadedInfo(),
      infiniteLoader: null,
    };
  },
  watch: {
    contracts: {
      handler: 'contractsHandler',
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile']),
    showLoader() {
      return !this.isComponentReady && !this.compactMode && !this.$route.params.marketId;
    },
    loaderNum() {
      return (this.isLayoutMobile) ? 2 : 5;
    },
    showHeader() {
      return (this.lightHeader) ? this.contracts.length > 0 : true;
    },
    headModifiers() {
      return {
        'contracts-history__head': true,
        'contracts-history--light': this.lightHeader,
      };
    },
    classModifiers() {
      return {
        'contracts-history--compact': this.compactMode,
      };
    },
    stickyOptions() {
      if (this.$router.currentRoute.name === 'market-details') {
        return this.isLayoutMobile ?
          stickyConstants.mobile :
          stickyConstants.desktop;
      }
      return this.isLayoutMobile ?
        stickyConstants.mobile :
        stickyConstants.desktop;
    },
    desktopColumns() {
      return !(this.isLayoutMobile || this.compactMode);
    },
  },
  methods: {
    contractsHandler(newValue, oldValue) {
      if (newValue.length > 0) {
        this.isComponentReady = true;
        if (this.infiniteLoader) {
          this.infiniteLoader.loaded();
          if (!this.canLoadMore) {
            this.infiniteLoader.complete();
          }
        }
        this.loadedInfo = this.getLoadedInfo();
      } else if (typeof oldValue === 'undefined') {
        this.loadedInfo = this.getLoadedInfo();
        this.isComponentReady = true;
      }
    },
    getLoadedInfo() {
      return (this.contracts.length > 0) ? NO_MORE_CONTRACTS_MESSAGE : NO_CONTRACTS_MESSAGE;
    },
    goInfinite(infi) {
      this.infiniteLoader = infi;
      this.$emit('loading', infi);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/contracts-history/contracts-history.js